import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { UrlService } from '@core/services/url/url.service';
import { AmsFile } from '@core/objects/ams-file';
import { PdfXfdfAnnotationChanges } from '@core/models/xfdf-annotator.model';

/**
 * service for XFDF annotations for Pdf viewer
 */
@Injectable({
    providedIn: 'root'
})
export class AnnotationsService {
    public readonly VERSION_SHARE_FEEDBACK_CONTEXT = 'version-share-feedback';

    constructor(public urlSrv: UrlService, public http: HttpClient){}

    // response type now should be text
    find(file: AmsFile, urlPrefix: string = "", context: string ="") {

        return this.http.get(this.getUpdatedUrl(urlPrefix + "/files/" + file.id + "/annotations", context), { responseType: 'text' });
    }

    // post content now is xml 
    save(file: AmsFile, annotations: PdfXfdfAnnotationChanges, urlPrefix: string = "",context: string = "" ) {

        let options = {headers: new HttpHeaders({
            // 'Content-Type':  'text/xml',
            'Content-Type':  'application/json'
        })};

        return this.http.post(
            this.getUpdatedUrl(urlPrefix+"/files/"+file.id+"/annotations", context), 
            annotations, 
            options
        );
    }

    // get annotations counter. Prefix will be given according where we call it
    // message files annotations url will be related to messages.
    getCounter( urlPrefix: string = "",context: string = "") {
        return this.http.get(this.getUpdatedUrl(urlPrefix+ "/annotations", context) );
    }

    // we avoid context for save in version files because we use /web/share url to do POST call
    private getUpdatedUrl(callableUrl: string, context: string ) : string {
        let url = callableUrl;
        if(context != this.VERSION_SHARE_FEEDBACK_CONTEXT ){
            url = this.urlSrv.build(callableUrl);
            // avoid /p for plugin annotatios url
            url = url.replace('/p/','/');
        }
        return url;
    }


    saveXfdf(file: AmsFile, annotations: PdfXfdfAnnotationChanges, urlPrefix: string = "", context: string = "") {

        let options = {
            headers: new HttpHeaders({
                // 'Content-Type':  'text/xml',
                'Content-Type': 'application/json'
            })
        };

        return this.http.post(
            this.getUpdatedUrl(urlPrefix + "/files/" + file.id + "/annotations", context),
            annotations,
            options
        );
    }
}
